import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Alert, Spinner, Row, Col, Card, ProgressBar, Button } from 'react-bootstrap';
import { LanguageProvider } from '../../../core/language-provider';
import { ResourceManager } from '../../../core/resource-manager';
import courseDefault from '../../../assets/course.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';





export default function CardContiua({ data }) {

    const navigate = useNavigate();
    const [errors, setErrors] = useState(null);
    const [image, setImage] = useState(null);
    const [timeRemain, setTimeRemain] = useState(null);


    useEffect(() => {
        console.log('data-card', data)
        setImage(data.idCourse.image ? ResourceManager.getFileUrl(data.idCourse.image, 'course') : courseDefault)
        var b = data.total_episodes_time - parseInt(data.total_user_time)
        b = b / 60
        setTimeRemain(parseInt(b))
    }, []);

    function clickAction() {
        navigate('/corsi/' + data.idCourse.id)
    }


    if (data) {
        return (
            <Card role="button" onClick={() => clickAction()} className='mt-3 mb-3 text-dark' style={{ borderRadius: '20px' }}>
                <Card.Img variant="top" src={image} style={{ borderStartEndRadius: '20px', borderStartStartRadius: '20px' }} />
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "60%",
                        background: 'linear-gradient(0deg, rgba(7, 74, 123, 0.00) 0%, #074A7B 89%)',
                        borderStartEndRadius: '20px',
                        borderStartStartRadius: '20px'
                    }}
                />
                <Card.ImgOverlay>
                    <Card.Title className='text-white'>
                        <b>{data.idCourse.name}</b>
                        <ProgressBar style={{ height: '10px' }} now={data.total_user_time} max={data.total_episodes_time} className='mt-2' />
                    </Card.Title>
                </Card.ImgOverlay>
                <Card.Body>
                    <Row className='justify-content-around'>
                        <Col>Ti restano<br />
                            {timeRemain} minuti</Col>
                        <Col>
                            <Button className='px-3 rounded-pill'>Continua<FontAwesomeIcon className='ms-2' icon="circle-play"></FontAwesomeIcon></Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }

};